// Reader for the legacy friend-request QR payload.
//
// NOTHING BUILDS THESE ANY MORE. Profile QRs now encode the share-code link
// (https://scan.hadv.quest/U<code>), the same payload the mobile app has always
// used — see ShareProfileQrDialog for why. This module is kept because the
// codes it reads outlived the encoder: a `hadv:friend:` QR only ever existed as
// a screenshot or a photo of somebody's screen, and those do not expire on
// their own. Deleting the parser would break every one still in a camera roll.
//
// So this is deliberately a decoder without an encoder. If you are looking for
// how to make a profile QR, it is buildShareCodeUrl in
// features/adventures/utils/shareLink.

/**
 * Prefix used on the retired profile-share QR payloads. Scanners detect this
 * prefix and short-circuit into the friend-request prompt instead of treating
 * the payload as a share code.
 */
export const FRIEND_QR_PREFIX = 'hadv:friend:'

/**
 * Returns the target userId when the scanned payload is one of our friend
 * tokens; null otherwise. Accepts a `?` / `#` suffix in case future
 * encodings want to add query parameters.
 */
export function parseFriendQrPayload(value: string | null | undefined): string | null {
  if (!value) return null
  if (!value.startsWith(FRIEND_QR_PREFIX)) return null
  const rest = value.slice(FRIEND_QR_PREFIX.length).split(/[?#]/)[0]?.trim()
  return rest && rest.length > 0 ? rest : null
}
